<script>
  import { onMount } from 'svelte';

  import { __ } from '~/data-utils';
  import { lang } from 'apps/imd/stores';
  import Events from '~/events';

  import CircleButton from 'components/CircleButton.svelte';

  let content_lowered = false;
  let toggleIcon;
  let toggleText = '';

  // Update when toggle or language changes
  $: if ($lang) {
    toggleIcon = content_lowered ? 'ic_chevron-up' : 'ic_chevron-down';
    toggleText = __(content_lowered ? 'uitransform.up' : 'uitransform.down');
  }

  function toggle () {
    content_lowered = !content_lowered;
    Events.dispatchEvent(
      'ui:transform', content_lowered ? 'lower' : 'normal'
    );

    const body = document.querySelector('body');
    body.classList.toggle('screen-mode-lower', content_lowered);
  }

  onMount(() => {
    const page = document.getElementById('page-container');
    function returnUp ({ target }) {
      if (target == page && content_lowered) toggle();
    }
    page.addEventListener('click', returnUp);
    return () => page.removeEventListener('click', returnUp);
  });
</script>

<CircleButton icon={toggleIcon} on:click={toggle}>{toggleText}</CircleButton>

<style media="screen">
  :global(.view),
  :global(.vg__map) {
    transform: translateY(0);
    transition: transform .2s;
  }

  :global(.screen-mode-lower .view) {
    transform: translateY(45%);
  }

  :global(.screen-mode-lower .vg__map) {
    transform: translateY(calc(45% + 96px));
  }


  :global(.landscape .view:before) {
    content: ' ';
    display: block;
    position: absolute;
    top: -48px;
    left: 50%;
    height: 0;
    width: 0;
    transform: translateX(-50%);
    background: #fff;
    border-radius: 50px;
    transition: all .3s .2s;
  }

  :global(.landscape.screen-mode-lower .view:before) {
    height: 16px;
    width: 64px;
  }
</style>
